import { generatedApi } from '@shared/api';
import { store } from '@shared/redux';
import { socket } from '../..';

export const handleChangeCurrentAgent = () => {
  return socket.onMessage('CHANGE_CURRENT_AGENT', (payload) => {
    const clientId = payload.client_id;
    const currentAgentId = payload.current_agent_id;

    if (typeof clientId !== 'number' || typeof currentAgentId !== 'number') return;

    const cachedArgs = generatedApi.util.selectCachedArgsForQuery(
      store.getState(),
      'getClientFieldsClientFieldsGet',
    );

    let hasQueryForClient = false;
    let hasCurrentAgentInCache = false;

    cachedArgs?.forEach((args) => {
      if ((args as { clientId?: number })?.clientId !== clientId) return;
      hasQueryForClient = true;

      store.dispatch(
        generatedApi.util.updateQueryData('getClientFieldsClientFieldsGet', args, (draft) => {
          const draftAgents = draft as Array<{ agent_id: number; current_agent: boolean }>;

          const foundAgent = draftAgents.some((agent) => agent.agent_id === currentAgentId);
          if (foundAgent) {
            hasCurrentAgentInCache = true;
          }

          draftAgents.forEach((agent) => {
            agent.current_agent = agent.agent_id === currentAgentId;
          });
        }),
      );
    });

    if (hasQueryForClient && !hasCurrentAgentInCache) {
      store.dispatch(
        generatedApi.endpoints.getClientFieldsClientFieldsGet.initiate(
          { clientId },
          {
            forceRefetch: true,
            subscribe: false,
          },
        ),
      );
    }
  });
};
